import React, { useState, useEffect} from 'react';
import { configData } from "../config";
import { useParams } from 'react-router-dom';
import ReactDOM from "react-dom/client";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import SweetAlert from "react-sweetalert2";	
import Swal from 'sweetalert2';


function EventlogMore() {

    var {uid} = useParams();
    
    const [isLoading, setIsLoading] = useState(true);
    
    const app_url = configData.APP_URL;
    const [eventformData, setEventFormData] = useState({
        loggedin_uid: localStorage.getItem('drupal_uid'),
        drupal_uid: uid,
        subject: 'Out Bound Call',
        details: '',
        lead_score: '',
    disqualified_reason: '',
    disqualified_reason_other: ''
    });
    const [eventlist, setEventList] = useState({});
    const [eventdetailedview, setEventDetailedView] = useState({});
    const [userDetails, setUserDetails] = useState({});
    // const[showEventModal, setShowEventModal] = useState(false);
    // const[showEventViewModal, setShowEventViewModal] = useState(false);
    const [activeModal, setActiveModal] = useState(null);
    var currentdate = new Date().toLocaleDateString();
    var currenttime = new Date().toLocaleTimeString();
    var currentdatetime = currentdate+' '+currenttime;
    
    useEffect(()=>{
        geteventlist();
        getuserdetails();
            setTimeout(() => {
                setIsLoading(false);
              }, 1000);
            
        },[])
    
    //     const handleModalOpen = (modalname) => {
    //     if(modalname == 'add_event_log') {
    //         // setShowEventModal(true);
    //         setActiveModal('add_event_log');
    //     }
    //     if(modalname == 'view_event_log') {
    //         // setShowEventViewModal(true);
    //         setActiveModal('view_event_log');
    //     }
       
        
    // };
    const handleModalOpen = (modalname) => {
        setActiveModal(null);
            setTimeout(() => {
            setActiveModal(modalname); //  open again
        }, 10);
    };

    const handleViewModalOpen = async (modalname,eventid) => {
        setActiveModal(null);
    setTimeout(async () => {
        setActiveModal(modalname);
        // if(modalname == 'add_event_log') {
        //     // setShowEventModal(true);
        //     setActiveModal('add_event_log');
        // }
        if(modalname == 'view_event_log') {
            // setShowEventViewModal(true);
            // setActiveModal('view_event_log');
          
            if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwweventlog/getusereventdetailedview?uid='+uid+'&eventid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setEventDetailedView(responsedata.data.result);
                    
                } 
                } catch (err) {
                }
            }
        

        }
       }, 10); 
    };
    // const handleModalClose = (modalname) => {
    //     if(modalname == 'add_event_log') {
    //     setShowEventModal(false);
    //     }
    //     if(modalname == 'view_event_log') {
    //     setShowEventViewModal(false);
    //     setEventDetailedView({});
    //     }
        
    // };
    const handleModalClose = () => {
        setActiveModal(null);
        setEventDetailedView({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEventFormData({ ...eventformData, [name]: value });
    };

  async function geteventlist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwweventlog/getuserfulleventlist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setEventList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
   async function getuserdetails() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwweventlog/getuserdetails?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setUserDetails(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
  const handleSubmit = async event => {
    if (eventformData.lead_score === 'Disqualified') {
        
        
        if (!eventformData.disqualified_reason) {
          alert('Please select a Disqualified Reason.');
            return;
        }

        // If reason is Other, Other text is also required
        if (
            eventformData.disqualified_reason === 'Other' &&
            !eventformData.disqualified_reason_other.trim()
        ) {
          alert('Please enter the reason in the Other field.');
           
            return;
        }
    }
        event.preventDefault();
        const postData = eventformData;
        const response = await fetch(app_url + 'smwweventlog/addevent', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            // setShowEventModal(false);
            setActiveModal(null);
            Swal.close();
            setEventList(data.data.result);
        }
    };
     return (
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
 
            <div class="left"></div>

            <div class="center left-center event-log-more">
                <Helmet><title>User Event Logs</title></Helmet>
              <h2>{userDetails.user_name}</h2>
                <table id="event_logs_js" className="EventLog white event-log-more-table"  border="0" cellpadding="2"  cellspacing="0">
                <colgroup>
                    <col style={{width: "5%"}}></col>
                    <col style={{width: "15%"}}></col>
                    <col style={{width: "20%"}}></col>
                    <col style={{width: "20%"}}></col>
                    <col style={{width: "40%"}}></col>
                </colgroup>

        <tbody>
            <tr valign="top">
                <td height="17" colspan="4" valign="top" align="left" class="infobar"></td>
                <td align="right" class="infobar outbound_image">
                    <a href onClick={() => handleModalOpen('add_event_log')} style={{'cursor':'pointer'}} title="Event Log" class="thickbox"><img src="/basic/web/images/outboundcall.gif" alt="Out Bound Call" title="Out Bound Call" border="0" align="top"/></a>
                </td>
            </tr>
           
               <tr style={{'background-color':'#CCCCCC' }} valign="top">
                <td>&nbsp;</td><td><b>Date</b></td><td><b>Who</b></td><td><b>Subject</b></td><td><b>Details</b></td>
            </tr>
               
             {eventlist.length > 0 ? (
            <>
            {eventlist.map((item, index) => {
                return <>
               <tr valign="top">
                <td><img src="/basic/web/images/viewlog.gif" style={{'cursor':'pointer'}} onClick={() => handleViewModalOpen('view_event_log',item['event_id'])}/></td><td>{item['date']}</td><td>{item['who']}</td><td>{item['subject']}</td><td dangerouslySetInnerHTML={{ __html: item['details'] }}></td>
            </tr>
                </>
                    
            })}  
            </>
            ) : (
                <><tr id="no_events"><td colspan="5"><b>There are no events associated to this record</b></td></tr></>
            )}
            
        </tbody>
        </table>
        {/* {showEventModal && (   */}
        {activeModal === 'add_event_log' && (
             <SweetAlert
               key="add_event_log"
                show={true}
                title="Add Event Log"
                showConfirmButton={false}
                showCloseButton={true}
                heightAuto={false}
               // didClose={handleModalClose}		
                onCancel={handleModalClose}
                customClass={{
                title: 'viewuserprofile-title-modal-header',
                closeButton: 'viewuserprofile-closebutton-modal-header'
              }}  
                >          
{/* <div id="myModal" class="modal add-event-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      
      <h2>Add Event Log</h2>
      <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('add_event_log')}>&times;</span>
    </div> */}
    <div class="modal-body">
      <form id="athlete_eventlog" method="post">
       <table className='modal-table'><tbody>
        
  <tr><td>Entering event for: </td><td><strong>{userDetails.user_name}</strong></td></tr>
	<tr><td>By User: </td><td><strong>{userDetails.loggedin_user_name}</strong></td></tr>
	<tr><td>Start Time:</td><td>{currentdatetime}</td></tr>
<tr>
	<td>Subject:</td>
	<td><input type="text" name="subject" defaultValue="Out Bound Call" onChange={handleChange} /></td>
</tr>
<tr>
	<td>Details:</td>
	<td><textarea name="details" cols="40" rows="7" onChange={handleChange} ></textarea></td>
</tr>
{/* Lead Score */}
            <tr>
                <td>Lead Score:</td>
                <td>
                    <select
                        name="lead_score"
                        value={eventformData.lead_score || ''}
                        onChange={handleChange}
                    >
                        <option value="">Select Lead Score</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                        <option value="Disqualified">Disqualified</option>
                    </select>
                </td>
            </tr>

            {/* Disqualified Reason */}
            {eventformData.lead_score === 'Disqualified' && (
                <tr>
                    <td>Disqualified Reason:</td>
                    <td>
                        <select
                            name="disqualified_reason"
                            value={eventformData.disqualified_reason || ''}
                            onChange={handleChange}
                        >
                            <option value="">Select Reason</option>
                            <option value="Player">Player</option>
                            <option value="No money">No money</option>
                            <option value="Doesn't understand product">
                                Doesn't understand product
                            </option>
                            <option value="Crazy">Crazy</option>
                            <option value="Other">Other</option>
                        </select>
                    </td>
                </tr>
            )}

            {/* Other Disqualified Reason */}
            {eventformData.disqualified_reason === 'Other' && (
                <tr>
                    <td>Other Reason:</td>
                    <td>
                        <textarea
                            name="disqualified_reason_other"
                            cols="40"
                            rows="3"
                            value={eventformData.disqualified_reason_other || ''}
                            onChange={handleChange}
                        ></textarea>
                    </td>
                </tr>
            )}
<tr>
	<td></td>
	<td><input type="button" id="btn" name="btn" class="event-save" value="Save" onClick={handleSubmit}/></td>
</tr>
</tbody></table>
</form>
    </div>
    <div class="modal-footer">
     
    </div>
  {/* </div>

</div>
  )} */}
</SweetAlert>
  )}
   {/* {showEventViewModal && (           
<div id="myModal" className="modal view-event-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      
      <h2>View Event Log</h2>
      <span class="close" onClick={() => handleModalClose('view_event_log')}>&times;</span>
    </div> */}
    {activeModal === 'view_event_log' && (
      		 <SweetAlert
   key="view_event_log"
    show={true}
  title="View Event Log"
  showConfirmButton={false}
  showCloseButton={true}
  heightAuto={false}
  //didClose={handleModalClose}	
  onCancel={handleModalClose}	
  customClass={{
    title: 'viewuserprofile-title-modal-header',
    closeButton: 'viewuserprofile-closebutton-modal-header'
  }} 
  > 
    <div class="modal-body">
        <table id="view-evenglog" className='event-log-view-table'>
        <tbody>
        <tr>
            
            <td>EventID: <strong>{eventdetailedview.EventID}</strong></td>
            <td>Entered By: <strong>{eventdetailedview.EnteredBy}</strong>
            
            </td>
        </tr>
  
        <tr>
            <td>Event Date: <strong>{eventdetailedview.EventDate}</strong></td>
        </tr>
        <tr>
            <td>Bound To: <strong>{eventdetailedview.drupal_uid}</strong></td>
        </tr>
        <tr>
            <td colSpan={2}>Subject: <strong>{eventdetailedview.Subject}</strong></td>
        </tr>
        <tr>
          <td colSpan={2}>Details: <strong dangerouslySetInnerHTML={{ __html: eventdetailedview.Details }}></strong></td>
        </tr>
        </tbody>
        </table>
    </div>
   
  {/* </div>

</div>
  )} */}
        </SweetAlert>
    )}
            </div>
        </div>
        )}
    </>
    
      );
      
}
export default EventlogMore;